import React from 'react';
import {Dialog, Button, DialogTitle, DialogContent, DialogActions, IconButton} from '@mui/material/';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslate } from 'react-admin';

function DialogMessage({ open, onClose, title, message, showCloseButton, showActions }) {
  const translate = useTranslate()

  return (
    <Dialog open={open} onClose={onClose} className='dialog-message'>
      {title &&
        <DialogTitle >
          {title}
          {showCloseButton && (
            <IconButton aria-label="close" onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
              <CloseIcon />
            </IconButton>
          )} </DialogTitle>}
      <DialogContent>
        {message}
      </DialogContent>
      {showActions && (
        <DialogActions>
          <Button onClick={onClose}>{translate('ra.action.close')}</Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default DialogMessage;
